import { useEffect, useReducer } from 'react';
import { persistedDataIsFilled } from 'components/cef_form/PostcodeSelector/postcodeSelectorUtils';
import updateMultipleFormValues from 'utils/hook-form/updateMultipleFormValues';
import { mapAddressToFields } from './addressDataModels';
import { reducer, initialState } from './postcodeSelectorsStateManager';

const usePostcodeSelectors = (watchedFields, setValue) => {
  const {
    companyType,
    addressOne,
    addressTwo,
    billingAddressMatchesRegistered,
  } = watchedFields;

  const [state, dispatch] = useReducer(
    reducer,
    initialState(addressOne, addressTwo),
  );

  const {
    postcodeSearched,
    postcodeIsReset,
    hasPersistedData,
    addressIsDuplicated,
  } = state;

  const setPersistedData = (field, value) => {
    dispatch({
      type: 'SET_PERSISTED_DATA',
      payload: { field, value },
    });
  };

  // Set persisted data in address fields if it is detected
  useEffect(() => {
    // Main route (CH API failure only)
    setPersistedData(
      'manualCompanyHasPersistedData',
      persistedDataIsFilled(addressOne),
    );
    // Sole trader route
    setPersistedData('homeHasPersistedData', persistedDataIsFilled(addressOne));
  }, [addressOne]);

  useEffect(() => {
    // Main route
    setPersistedData(
      'billingHasPersistedData',
      persistedDataIsFilled(addressTwo),
    );
    // Sole trader route
    setPersistedData(
      'previousHasPersistedData',
      persistedDataIsFilled(addressTwo),
    );
  }, [addressTwo]);

  // Detect if billing address matches registered address
  useEffect(() => {
    if (
      !addressIsDuplicated &&
      companyType !== '1' &&
      billingAddressMatchesRegistered
    ) {
      dispatch({
        type: 'SET_ADDRESS_DUPLICATED',
        payload: true,
      });
      updateMultipleFormValues(setValue, mapAddressToFields(2, addressOne));
    }
  }, [
    companyType,
    billingAddressMatchesRegistered,
    addressOne,
    addressIsDuplicated,
  ]);

  return {
    dispatch,
    postcodeSearched,
    postcodeIsReset,
    hasPersistedData,
    addressIsDuplicated,
  };
};

export default usePostcodeSelectors;
